import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-customicon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './customicon.component.html',
  styleUrl: './customicon.component.scss',
})
export class CustomiconComponent implements OnInit {
  @Input() name!: string;
  @Input() size?: number | null = null;
  @Input() width?: number | null = null;
  @Input() height?: number | null = null;
  @Input() color: string | null = null;

  constructor() {}

  ngOnInit() {}
}
